import BackTop from './BackTop';
export default BackTop;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-backtop/src/index.js